// extracted by mini-css-extract-plugin
export var main = "contact-module--main--3SZOr";
export var backImg = "contact-module--backImg--1NLE1";
export var phoneandmail = "contact-module--phoneandmail--UfWH1";
export var address = "contact-module--address--3fPC0";
export var about = "contact-module--about--3z1DJ";
export var title = "contact-module--title--208Ek";
export var stroke = "contact-module--stroke--3RzhL";
export var abouttext = "contact-module--abouttext--2OpvK";
export var socialmedia1 = "contact-module--socialmedia1--1aH5z";
export var socialmedia2 = "contact-module--socialmedia2--iWThx";
export var developedBy = "contact-module--developedBy--27UqG";
export var northic = "contact-module--northic--3qGkE";